package com.jet.classroomhero.data.remote.exceptions


// 500 errors
class CHServerResponseError(error: String? = "") : Exception(error)